import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { SharedCommonUtility } from '@shared/utils/common.utility';
import { SharedModule } from '../../../../shared/shared.module';

const MIN_OUTPOST_VERSION_FOR_CONFIGURABLE_TIMEOUT: string = '1.0.96';
const LEGACY_SCAN_TIMEOUT_HOURS: number = 24;

@Component({
  selector: 'app-scan-default-timeout',
  templateUrl: './scan-default-timeout.component.html',
  styleUrls: ['./scan-default-timeout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [SharedModule],
  standalone: true,
})
export class ScanDefaultTimeoutComponent {
  public readonly legacyScanTimeoutHours: number = LEGACY_SCAN_TIMEOUT_HOURS;

  @Input()
  public form: UntypedFormGroup;
  @Input()
  public fieldName: string;
  @Input()
  public formValidationRequest$: Observable<void>;
  @Input()
  public minScanTimeoutHours: number;
  @Input()
  public maxScanTimeoutHours: number;
  @Input()
  public scanningAgentCurrentVersion: string | null | undefined;

  // Deliberately computed here (client) rather than as a precomputed flag from the admin API: this reads the
  // form's live, unsaved value, so the warning appears the moment an admin types a value
  public get showOutpostVersionWarning(): boolean {
    const scanDefaultTimeoutHours: number = this.form?.get(this.fieldName)?.value;

    return (
      SharedCommonUtility.notNullish(scanDefaultTimeoutHours) &&
      SharedCommonUtility.notNullishOrEmpty(this.scanningAgentCurrentVersion) &&
      this.scanningAgentCurrentVersion.localeCompare(MIN_OUTPOST_VERSION_FOR_CONFIGURABLE_TIMEOUT, undefined, {
        numeric: true,
        sensitivity: 'base',
      }) < 0
    );
  }
}
